var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader",style:('border-color: '+_vm.bgColor+'; border-top-color: '+_vm.foreColor+';')})
}
var staticRenderFns = []

export { render, staticRenderFns }